import { useEffect } from "react";

/**
 * Espelha um estado de UI numa classe do <body> (menu-opened, search-opened,
 * header-reduced…), permitindo que o CSS reaja fora da árvore do React.
 */
export function useBodyClass(className: string, active: boolean): void {
	useEffect(() => {
		if (!active) return;
		document.body.classList.add(className);
		return () => document.body.classList.remove(className);
	}, [className, active]);
}
